'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProductTile = require('components/ProductTile');

var _ProductTile2 = _interopRequireDefault(_ProductTile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dom = {
  scroller: 'data-scroll-container',
  scrollTarget: 'data-scroll-target'
};

var state = {};

// Parameters
//    products: array of product objects
//    container: the HTML element to add all the products to
// Takes in a set of products and displays product tiles
var setupProductTiles = function setupProductTiles(products, container) {
  products.forEach(function (product) {
    var newProduct = _ProductTile2.default.buildProduct(product);
    container.appendChild(newProduct);
  });
};

// Grab all the product tile containers, and then set each up with it's products
var setupProductTileGroups = function setupProductTileGroups() {
  var productTileContainers = document.querySelectorAll('[data-collection-handle]');
  var productDataPromises = [];

  productTileContainers.forEach(function (container) {
    // Grab the collection handle for loading in the products
    var handle = container.dataset.collectionHandle;

    productDataPromises.push(fetch('/collections/' + handle + '?view=products-json').then(function (blob) {
      return blob.text();
    }).then(function (collectionRaw) {
      // Admin customizer adds HTML comments, which are break JSON parsing. Need to manually remove them
      var products = collectionRaw.replace(/<\!--.*?-->/g, "");
      return JSON.parse(products);
    }).then(function (products) {
      return setupProductTiles(products, container);
    }));
  });

  // wait for all fetches to resolve with product data
  Promise.all(productDataPromises).then(function () {
    // now setup any product tile stuffs
    _ProductTile2.default.bindActions();
    _ProductTile2.default.addProductLazyLoading();
    setupScroller();
  });
};

/**
 * Callback for scrollers being clicked
 */
var scrollContainer = function scrollContainer(event) {
  var scroller = event.target;
  var scrollID = scroller.getAttribute(dom.scroller);
  if (state[scrollID]) {
    return;
  }
  var toScroll = document.querySelector('[' + dom.scrollTarget + '="' + scrollID + '"]') || false;
  var interval = setInterval(function () {
    toScroll && toScroll.scrollBy({
      left: 200,
      behavior: 'smooth'
    });
  }, 200);
  // save the interval to state so we can cancel it later
  state[scrollID] = interval;
};

/**
 * Stop interval for scrolling product container
 */
var stopScroll = function stopScroll(event) {
  // get the interval to clear
  var scroller = event.target;
  var scrollID = scroller.getAttribute(dom.scroller);
  var interval = state[scrollID];
  // clear it
  clearInterval(interval);
  state[scrollID] = null;
};

/**
 * Setup scrollers to trigger scrolling on the product list
 */
var setupScroller = function setupScroller() {
  var scrollers = document.querySelectorAll('[' + dom.scroller + ']') || [];
  scrollers.forEach(function (scroller) {
    scroller.addEventListener('mousedown', scrollContainer);
    scroller.addEventListener('touchstart', scrollContainer);
    scroller.addEventListener('mouseup', stopScroll);
    scroller.addEventListener('touchend', stopScroll);
    scroller.addEventListener('mouseout', stopScroll);
  });
};

exports.default = {
  setupProductTileGroups: setupProductTileGroups,
  setupProductTiles: setupProductTiles
};